import $ from "jquery";
import slick from "slick-carousel";
import WOW from "wowjs";
import { DATA } from "./data";
import { Test } from "./test";

const test = new Test(DATA);

$(() => {
	test.init();

	$(".test-intro__btn").on("click", () => {
		$("body").addClass("show-test");
		$("html, body").animate(
			{
				scrollTop: $(".test").offset().top,
			},
			500
		);
	});

	$(".slider__container").slick();

	$(".banner__link").on("click", () => {
		$("html, body").animate(
			{
				scrollTop: $(".slider").offset().top,
			},
			500
		);
	});

	$(".slider__link").on("click", () => {
		$("html, body").animate(
			{
				scrollTop: $(".test-intro").offset().top,
			},
			500
		);
	});

	new fullpage("#fullpage", {
		scrollOverflow: true,
		scrollOverflowReset: true,
		afterSlideLoad: function (anchorLink, index, slideAnchor, slideIndex) {
			if (slideIndex != 0) {
				wow = new WOW({
					animateClass: "animated",
					live: true,
					boxClass: "wow",
				});
				wow.init();
			}
		},
		onSlideLeave: function (anchorLink, index, slideIndex, direction) {
			$(".section")
				.not(".slide-" + slideIndex)
				.find(".wow")
				.css("visibility", "hidden");
		},
	});

	$(".banner__button").on("click", () => {
		$("html, body").animate(
			{
				scrollTop: $(".slider__slide").offset().top,
			},
			500
		);
	});

	$(".result__description-btn").on("click", () => {
		$("html, body").animate(
			{
				scrollTop: $(".promo__wrap").offset().top,
			},
			500
		);
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js